import React from 'react'
import './css/Footer.css'
import InstagramIcon from '@mui/icons-material/Instagram'
import TwitterIcon from '@mui/icons-material/Twitter'
import EmailIcon from '@mui/icons-material/Email'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import { Link } from 'react-router-dom'
import Terms from './Terms'
export default function Footer () {
  const [open, setopen] = React.useState(false)

  return (
    <div>
      <div class='footer-basic'>
        <footer>
          <ul class='list-inline'>
            <li class='list-inline-item'>
              <a
                href='/#'
                onClick={() => {
                  setopen(true)
                }}
              >
                Terms
              </a>
            </li>
            <li class='list-inline-item'>
              <Link to='/privacypolicy'>
                <a href='/#'>Privacy Policy</a>
              </Link>
            </li>
          </ul>

          <div class='social'>
            <a href='https://www.instagram.com/yash____152000/'>
              <InstagramIcon />
            </a>
            <a
              href='mailto:batch23.dev@gmail.com'
            >
              <EmailIcon />
            </a>
            <a href='https://twitter.com/YASHMIS94967162'>
              <TwitterIcon />
            </a>
            <a href='https://www.facebook.com/profile.php?id=100038585474727'>
              <LinkedInIcon />
            </a>
          </div>
          <p className='copyright'>Major Project © 2023</p>
        </footer>
        <Terms open={open} setopen={setopen} />
      </div>
    </div>
  )
}
